import { Row } from "react-bootstrap";
import CancerIcon from "../assets/img/CancerIcon.png";
import HeartIcon from "../assets/img/HeartIcon.png";
import KneeIcon from "../assets/img/KneeIcon.png";
import SurgeryIcon from "../assets/img/SurgeryIcon.png";
import IVFIcon from "../assets/img/IVFIcon.png";
import ToothIcon from "../assets/img/ToothIcon.png";
import SpineIcon from "../assets/img/SpineIcon.svg";
import EyeIcon from "../assets/img/EyeIcon.png";

export const Treatments = () => {
  return (
    <section className="treatement" id="treatement">
      <Row style={{ marginRight: "0px" }}>
        <div className="treatementdiv">
          <h1>
            Medical{" "}
            <span style={{ color: "#306AFF" }}>
              <span className="pencilline4">Treatments</span>
            </span>
          </h1>
        </div>
      </Row>

      <Row style={{ marginRight: "0px" }} className="align-items-center">
        <div className="treatementrow">
          {/* Cancer Treatments */}
          <div className="treatementbox">
            <img className="treatementicon" src={CancerIcon} alt="CancerIcon" />
            <p>Cancer Treatments</p>
          </div>
          {/* Heart Treatments */}
          <div className="treatementbox">
            <img className="treatementicon" src={HeartIcon} alt="HeartIcon" />
            <p>Heart Treatments</p>
          </div>
          {/* Knee Replacement */}
          <div className="treatementbox">
            <img className="treatementicon" src={KneeIcon} alt="KneeIcon" />
            <p>Knee Replacement</p>
          </div>
          {/* Cosmetic Surgery */}
          <div className="treatementbox">
            <img
              className="treatementicon"
              src={SurgeryIcon}
              alt="SurgeryIcon"
            />
            <p>Cosmetic Surgery</p>
          </div>
        </div>
      </Row>
      <Row style={{ marginRight: "0px" }} className="align-items-center">
        <div className="treatementrow">
          {/* Fertility (IVF) */}
          <div className="treatementbox">
            <img className="treatementicon" src={IVFIcon} alt="IVFIcon" />
            <p>Fertility (IVF)</p>
          </div>
          {/* Dental Treatments */}
          <div className="treatementbox">
            <img className="treatementicon" src={ToothIcon} alt="ToothIcon" />
            <p>Dental Treatments</p>
          </div>
          {/* Spine Treatments */}
          <div className="treatementbox">
            <img className="treatementicon" src={SpineIcon} alt="SpineIcon" />
            <p>Spine Treatments</p>
          </div>
          {/* Eye Treatments */}
          <div className="treatementbox">
            <img className="treatementicon" src={EyeIcon} alt="EyeIcon" />
            <p>Eye Treatments</p>
          </div>
        </div>
      </Row>
    </section>
  );
};
